import { render } from "./boxFiles.vue?vue&type=template&id=49f22a43&scoped=true"
import script from "./boxFiles.vue?vue&type=script&lang=js"
export * from "./boxFiles.vue?vue&type=script&lang=js"

import "./boxFiles.vue?vue&type=style&index=0&id=49f22a43&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f22a43"]])

export default __exports__